module.exports = __webpack_public_path__ + "static/media/P1050710-min.f4b073b6.JPG";